import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { values } from "lodash";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { TextQuestion } from "../../questionnaires/components/questions/TextQuestion";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceSkinSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.Skin}
        >
            <h4>Have you ever had any of the following?</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadEczema),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadEczemaFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadFoodAllergies),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadFoodAllergiesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.WearLatexOrProtectiveGloves),
                    getQuestionConfig(props.questionConfigs, questionIds.LatexNitrilePolyVinylGloves)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {getAnswerToQuestionWithId(values(props.questions || {}), questionIds.WearLatexOrProtectiveGloves) === MultiButtonQuestion.YesOption &&
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HowMuchTimeWearingGloves)}
                readonly={props.readonly}
                options={[
                    { text: "Less than 15 minutes", value: "LessThan15Mins" },
                    { text: "15 minutes - 1 hour", value: "15MinsTo1Hour" },
                    { text: "1-2 hours", value: "1To2Hours" },
                    { text: "2-3 hours", value: "2To3Hours" },
                    { text: "3-5 hours", value: "3To5Hours" },
                    { text: "5-8 hours", value: "5To8Hours" },
                    { text: "More than 8 hours", value: "8+Hours" },
                ]}
            />}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.BarrierCream),
                    getQuestionConfig(props.questionConfigs, questionIds.BarrierCreamFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.MoisturisingCream),
                    getQuestionConfig(props.questionConfigs, questionIds.MoisturisingCreamFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Are you experiencing any of these symptoms at present?</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.RednessDrynessCracking),
                    getQuestionConfig(props.questionConfigs, questionIds.RednessDrynessCrackingFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.RashAfterWearingGloves),
                    getQuestionConfig(props.questionConfigs, questionIds.RashAfterWearingGlovesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.SwollenEyesAfterWearingGloves),
                    getQuestionConfig(props.questionConfigs, questionIds.SwollenEyesAfterWearingGlovesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.InflammationMucousMembranes),
                    getQuestionConfig(props.questionConfigs, questionIds.InflammationMucousMembranesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.AsthmaSymptoms),
                    getQuestionConfig(props.questionConfigs, questionIds.AsthmaSymptomsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ItchingBlistersAfterWearingGloves),
                    getQuestionConfig(props.questionConfigs, questionIds.ItchingBlistersAfterWearingGlovesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DryFlakySkin),
                    getQuestionConfig(props.questionConfigs, questionIds.DryFlakySkinFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.AllergicSkinReactions),
                    getQuestionConfig(props.questionConfigs, questionIds.AllergicSkinReactionsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.RednessSwellingSkin),
                    getQuestionConfig(props.questionConfigs, questionIds.RednessSwellingSkinFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ItchySkin),
                    getQuestionConfig(props.questionConfigs, questionIds.ItchySkinFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.OtherRashes),
                    getQuestionConfig(props.questionConfigs, questionIds.OtherRashesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Additional Questions</h4>
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.SkinImproveAwayFromWork)}
                readonly={props.readonly}
            />
            {getAnswerToQuestionWithId(values(props.questions || {}), questionIds.SkinImproveAwayFromWork) &&
                <TextQuestion
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.SkinImproveAwayFromWorkFurtherDetails)}
                    readonly={props.readonly}
                />
            }
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ReceivingTreatmentAtPresent),
                    getQuestionConfig(props.questionConfigs, questionIds.ReceivingTreatmentAtPresentFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceSkinSection = connect(makeMapStateToQuestionnaireSectionProps(sections.Skin.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceSkinSectionUnconnected);
